"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sortableTableHeader = _interopRequireDefault(require("../../../core/sortable-table-header"));
var _lateEntry = _interopRequireDefault(require("../../../../icons/late-entry"));
var _online = _interopRequireDefault(require("../../../../icons/online"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Several of the tabs within the manage entries section have a table of entries
// Although the entries may be of different types and therefore have some different actions for each row
// many of the columns are common to all entries.
// This section provides the heading for the part of the row that is common to all entries regardless of type
var _ref = /*#__PURE__*/_react.default.createElement("th", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null);
var _ref3 = /*#__PURE__*/_react.default.createElement("th", null);
var _ref4 = /*#__PURE__*/_react.default.createElement("th", null, "RTCs & Notes");
class EntriesTableHead extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("tr", null, _ref, _ref2, /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "entrySortDate",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Entered"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "day",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Day"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "race",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Race"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "rankingDivision",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Ranking"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "startListBib",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort,
      className: "text-xs-right "
    }, "Bib"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "bibName",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Name"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "ageCategory",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Age"), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "entryText",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Club"), !this.props.useFreeCode ? null : /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "freeCode",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Code"), _ref3, /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "isLateEntry",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort,
      title: "Late Entry. Click to Sort",
      className: "text-xs-center "
    }, /*#__PURE__*/_react.default.createElement(_lateEntry.default, {
      style: {
        margin: '.31em 0'
      }
    })), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "isOnlineEntry",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort,
      title: "Entered Online. Click to Sort",
      className: "text-xs-center "
    }, /*#__PURE__*/_react.default.createElement(_online.default, {
      style: {
        margin: '.31em 0'
      }
    })), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "hasPaid",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort,
      title: "Paid. Click to Sort",
      className: "text-xs-center "
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontFamily: 'bookman',
        fontWeight: '200',
        fontSize: '1.3em',
        lineHeight: '1.2em'
      }
    }, "\xA3")), /*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
      columnID: "entryType",
      sortedColumnID: this.props.sortedColumnID,
      sortedDirection: this.props.sortedDirection,
      onClick: this.props.onToggleSort
    }, "Type"), _ref4, this.props.children);
  }
}
var _default = exports.default = EntriesTableHead;